import styled from '@emotion/styled/macro';
import { Variables } from '../variables';

export const LoadingLine = styled.div`
    height: 1px;
    width: 100vw;
    background-color: ${Variables.Colors.b300_l76};
`;
